import React, { useContext, useEffect } from 'react';
import { EditCustomerContext, IEditCustomerContext } from '../../editCustomerState/editCustomerContext';
import LocalizationState from './components/LocalizationForm/localizationState/LocalizationState';
import { StyleState } from './components/StyleForm/styleState/StyleState';
import { BpaState } from './components/BpaForm/bpaState/BpaState';
import EditForm from './components/EditForm/EditForm';
import LocalizationForm from './components/LocalizationForm/LocalizationForm';
import StyleForm from './components/StyleForm/StyleForm';
import { BpaForm } from './components/BpaForm/BpaForm';
import { useRoleAccess } from 'hooks/useRoleAccess';
import { UserRoles } from 'types';
import style from './Forms.module.scss';

const Forms: React.FC = () => {
	const { changeVisibleForm, visibleForm } = useContext<IEditCustomerContext>(EditCustomerContext);
	const hasMainFormAccess = useRoleAccess([UserRoles.SUPER_USER]);
	const hasLocalizationFormAccess = useRoleAccess([
		UserRoles.SUPER_USER,
		UserRoles.CLIENT_MANAGER,
		UserRoles.GROUP_MANAGER,
		UserRoles.TECHNICAL,
	]);
	const hasStyleFormAccess = useRoleAccess([
		UserRoles.SUPER_USER,
		UserRoles.CLIENT_MANAGER,
		UserRoles.GROUP_MANAGER,
		UserRoles.TECHNICAL,
	]);
	const hasBpaFormAccess = useRoleAccess([UserRoles.SUPER_USER]);

	useEffect(() => {
		window.scrollTo(0, 0);
	}, [visibleForm]);

	useEffect(() => {
		if (hasMainFormAccess) {
			changeVisibleForm('mainForm');
		} else if (hasLocalizationFormAccess) {
			changeVisibleForm('localizationForm');
		} else if (hasStyleFormAccess) {
			changeVisibleForm('styleForm');
		} else if (hasBpaFormAccess) {
			changeVisibleForm('bpaForm');
		}
	}, [hasMainFormAccess, hasLocalizationFormAccess, hasStyleFormAccess, hasBpaFormAccess]);

	return (
		<div className={style.container} data-test="Forms">
			{hasMainFormAccess && <EditForm isVisible={visibleForm === 'mainForm'} />}
			{hasLocalizationFormAccess && (
				<LocalizationState>
					<LocalizationForm isVisible={visibleForm === 'localizationForm'} />
				</LocalizationState>
			)}
			{hasStyleFormAccess && (
				<StyleState>
					<StyleForm isVisible={visibleForm === 'styleForm'} />
				</StyleState>
			)}
			{hasBpaFormAccess && (
				<BpaState>
					<BpaForm isVisible={visibleForm === 'bpaForm'} />
				</BpaState>
			)}
		</div>
	);
};

export default Forms;
